"use strict";

import angular from "angular";

import { Events } from "../../../presentation/services/Events/Events";

class PopupOnboardingWelcomeDialogCtrl {
    constructor($mdDialog, locals, DSNDialogService) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.data = locals.data;
        this.DSNDialogService = DSNDialogService;

        this.Events = new Events();
    }
    $onInit() {}

    onHide() {
        this.Events.send(
            `Popup.Onboarding.BemVindo.${this.data.event}.Comecar`
        );

        this.$mdDialog.hide(true);
    }
}
angular
    .module("nucont.shared")
    .controller("PopupOnboardingWelcomeDialogCtrl", [
        "$mdDialog",
        "locals",
        "DSNDialogService",
        PopupOnboardingWelcomeDialogCtrl
    ]);
